import type { AppLocale } from "./i18n/locale-state";
import {
  DEFAULT_LOCALE,
  normalizeLocale,
  getLocale as sharedGetLocale,
  setLocale as sharedSetLocale,
  subscribeLocaleChange as sharedSubscribeLocaleChange,
} from "./i18n/locale-state";
import { createI18nRuntime, type MessageParams, type MessageTree } from "./i18n/runtime";

export const APP_NAME = "airange-admin";

export type { AppLocale } from "./i18n/locale-state";
export {
  APP_LOCALE_LABELS,
  APP_LOCALES,
  DEFAULT_LOCALE,
  getLocale,
  normalizeLocale,
  setLocale,
  subscribeLocaleChange,
} from "./i18n/locale-state";
export type { MessageParams, MessageTree } from "./i18n/runtime";

export type FormatMessageLike = (descriptor: { id: string }, values?: MessageParams) => string;

const localeCatalogs: Record<AppLocale, MessageTree> = {
  "zh-CN": {},
  en: {},
  ja: {},
};

function createRuntime() {
  return createI18nRuntime({
    defaultLocale: DEFAULT_LOCALE,
    localeCatalogs,
    normalizeLocale,
    localeState: {
      getLocale: sharedGetLocale,
      setLocale: sharedSetLocale,
      subscribeLocaleChange: sharedSubscribeLocaleChange,
    },
  });
}

let activeRuntime = createRuntime();

/** Registers the complete catalog owned by a loaded admin locale chunk. */
export function registerLocaleCatalog(locale: AppLocale, catalog: MessageTree) {
  if (localeCatalogs[locale] === catalog) {
    return;
  }
  localeCatalogs[locale] = catalog;
  activeRuntime = createRuntime();
}

export const t = (path: string, params?: MessageParams, locale?: string) =>
  activeRuntime.t(path, params, locale);
export const formatMessage = activeRuntime.formatMessage;

export function formatActionObjectIntlLabel(
  formatMessage: FormatMessageLike,
  locale: string | null | undefined,
  actionId: string,
  objectId: string,
  actionValues?: MessageParams,
  objectValues?: MessageParams,
) {
  const actionLabel = formatMessage({ id: actionId }, actionValues);
  const objectLabel = formatMessage({ id: objectId }, objectValues);
  const normalizedLocale = String(locale ?? "")
    .trim()
    .toLowerCase();
  if (["ja", "ja-jp"].includes(normalizedLocale)) {
    return `${objectLabel}を${actionLabel}`;
  }
  if (["en", "en-us", "en-gb"].includes(normalizedLocale)) {
    return `${actionLabel} ${objectLabel}`.trim();
  }
  return `${actionLabel}${objectLabel}`.trim();
}
